import React, {useEffect, useState} from "react";
import axios from "axios";
import {useTranslation} from "react-i18next";
import {Avatar, Divider, Space} from "antd";
import Search from "antd/es/input/Search";
import {arrRemove, globalData, setKey} from "../util/util";
import List from "antd/es/list";
import Icon from "./Icon";
import {Link} from "react-router-dom";
import Tag from "antd/es/tag";
import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";

export default (prop) => {

    const {t} = useTranslation()
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [pageInfo, setPageInfo] = useState({
        current: 1,
        pageSize: 12,
        showSizeChanger: false,
        onChange : (current, pageSize) => {
            pageInfo.current = current
            pageInfo.pageSize = pageSize
            setPageInfo({...pageInfo})
            update()
        }
    })

    const update = () => {
        setLoading(true)
        axios.get(`player/following`, {
            params: {
                current: pageInfo.current,
                pageSize: 12,
                handle: prop.playerHandle,
            }
        }).then(res => {
            pageInfo.total = res.total
            setKey(res.records, "handle")
            setData(res.records)
            setLoading(false)
        })
    }

    useEffect(() => {
        update()
    }, [prop.playerHandle])

    return <Space direction={'vertical'}>
        {
            data.length > 0 &&
            <Space>
                <List pagination={pageInfo} style={{ width: "600px",fontSize: "20px" }}
                      size="small"
                      bordered
                      dataSource={data}
                      renderItem={(p) => <List.Item>
                          <div style={{ position: "relative", width: "100%" }}>
                              <Link to={`/player/${p.handle}`} >
                                  <Space>
                                      {
                                          p.pfp > 0 ? <Avatar src={`https://www.aslucky.club/file/touhou/pfp/${p.handle}.png?r=${p.pfp}`} shape="square" size={40} icon={<UserOutlined />} />
                                              : <Avatar shape="square" size={40} icon={<UserOutlined />} />
                                      }
                                      <span>{p.clanTag ? `<${p.clanTag}>` : ''}{p.name}</span>
                                      <span>{p.handle}</span>
                                  </Space>
                              </Link>
                              <div style={{ position: "absolute", right: 10, top: -2 }}>
                                  <Icon  name={p.region} type={'region'} size={30} />
                              </div>
                          </div>
                      </List.Item>}
                />
            </Space>|| null
        }

    </Space>
}
